import { render, staticRenderFns } from "./ActivityMonitorItem.vue?vue&type=template&id=3bfa5e3f&scoped=true"
import script from "./ActivityMonitorItem.vue?vue&type=script&lang=ts"
export * from "./ActivityMonitorItem.vue?vue&type=script&lang=ts"
import style0 from "./ActivityMonitorItem.vue?vue&type=style&index=0&id=3bfa5e3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfa5e3f",
  null
  
)

export default component.exports